(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/tipsinfo/assets/javascripts/tipsinfo-table.js') >= 0) return;  svs.modules.push('/components/tipsen/tipsinfo/assets/javascripts/tipsinfo-table.js');
"use strict";


const _svs$components$tipse = svs.components.tipsen.tipsinfo.utils,
  getOddsCaption = _svs$components$tipse.getOddsCaption,
  formatDecimalOdds = _svs$components$tipse.formatDecimalOdds,
  formatPercentage = _svs$components$tipse.formatPercentage,
  setUpTipsinfoValue = _svs$components$tipse.setUpTipsinfoValue;
const TableComponent = svs.components.tipsen.tipsinfo.tableComponents.TableComponent;
const Trend = svs.components.lbUi.trend.Trend;
const _svs$components$tipse2 = svs.components.tipsen.tipsinfo,
  AnalysisForecast = _svs$components$tipse2.AnalysisForecast,
  TipsinfoTableRow = _svs$components$tipse2.TipsinfoTableRow;
const TipsinfoTable = _ref => {
  let layOutProps = _ref.layOutProps;
  const drawNumber = layOutProps.drawNumber,
    eventNumber = layOutProps.eventNumber,
    favourites = layOutProps.favourites,
    hasTioTidningarValues = layOutProps.hasTioTidningarValues,
    hasTipsinfoStats = layOutProps.hasTipsinfoStats,
    isReduceFree = layOutProps.isReduceFree,
    isResultOrMybets = layOutProps.isResultOrMybets,
    isStartOddsEnabled = layOutProps.isStartOddsEnabled,
    matchId = layOutProps.matchId,
    outcomeLabels = layOutProps.outcomeLabels,
    productId = layOutProps.productId,
    selectFormattedDistribution = layOutProps.selectFormattedDistribution,
    selectFormattedOdds = layOutProps.selectFormattedOdds,
    shouldDisplayFavourites = layOutProps.shouldDisplayFavourites,
    shouldDisplayOdds = layOutProps.shouldDisplayOdds,
    shouldDisplayStartOdds = layOutProps.shouldDisplayStartOdds,
    shouldDisplaySvenskaFolket = layOutProps.shouldDisplaySvenskaFolket,
    shouldDisplayTioTidningar = layOutProps.shouldDisplayTioTidningar,
    showMatchAnalyseForecast = layOutProps.showMatchAnalyseForecast,
    startOdds = layOutProps.startOdds,
    tioTidningarTips = layOutProps.tioTidningarTips;
  return React.createElement(TableComponent, {
    ariaDescription: "Tipsinformation f\xF6r match nummer ".concat(eventNumber)
  }, React.createElement(TableComponent.Header, {
    className: isReduceFree && hasTipsinfoStats ? '' : 'sr-only'
  }, React.createElement(TableComponent.Header.Row, null, React.createElement(TableComponent.Header.Row.HeaderCell, null, isReduceFree && hasTipsinfoStats ? '' : 'Tipsinfo'), outcomeLabels === null || outcomeLabels === void 0 ? void 0 : outcomeLabels.map(outcomeLabel => React.createElement(TableComponent.Header.Row.HeaderCell, {
    className: "tips_info_table_content_header",
    key: "header_content_".concat(drawNumber, "_").concat(matchId, "_").concat(outcomeLabel.text),
    scope: "col"
  }, outcomeLabel.text)))), React.createElement(TableComponent.Body, null, shouldDisplaySvenskaFolket && React.createElement(TipsinfoTableRow, {
    dataTestId: "coupon-row-tips-info-svenska-folket",
    title: "Svenska folket"
  }, outcomeLabels === null || outcomeLabels === void 0 ? void 0 : outcomeLabels.map((outcomeLabel, i) => React.createElement(TableComponent.Body.Row.ContentCell, {
    key: "sv_".concat(drawNumber, "_").concat(matchId, "_").concat(outcomeLabel.text)
  }, React.createElement(Trend, {
    postfixSymbol: "%",
    selectorFunction: selectFormattedDistribution(i),
    uniqueId: "".concat(drawNumber, "_").concat(matchId, "_").concat(outcomeLabel.text)
  })))), shouldDisplayOdds && React.createElement(TipsinfoTableRow, {
    dataTestId: "coupon-row-tips-info-odds",
    title: getOddsCaption({
      isStartOddsEnabled,
      isResultOrMybets
    })
  }, outcomeLabels === null || outcomeLabels === void 0 ? void 0 : outcomeLabels.map((outcomeLabel, i) => React.createElement(TableComponent.Body.Row.ContentCell, {
    key: "odds_".concat(drawNumber, "_").concat(matchId, "_").concat(outcomeLabel.text)
  }, React.createElement(Trend, {
    selectorFunction: selectFormattedOdds(i),
    uniqueId: "".concat(drawNumber, "_").concat(matchId, "_").concat(outcomeLabel.text)
  })))), shouldDisplayFavourites && React.createElement(TipsinfoTableRow, {
    dataTestId: "coupon-row-tips-info-favourites",
    title: "Favoritskap"
  }, outcomeLabels === null || outcomeLabels === void 0 ? void 0 : outcomeLabels.map((outcomeLabel, i) => {
    var _favourites$current;
    return React.createElement(TableComponent.Body.Row.ContentCell, {
      key: "favourites_".concat(drawNumber, "_").concat(matchId, "_").concat(outcomeLabel.text)
    }, setUpTipsinfoValue({
      value: formatPercentage(favourites === null || favourites === void 0 || (_favourites$current = favourites.current) === null || _favourites$current === void 0 ? void 0 : _favourites$current.value[i]),
      sign: '%',
      noValueSign: '-'
    }));
  })), shouldDisplayStartOdds && React.createElement(TipsinfoTableRow, {
    dataTestId: "coupon-row-tips-info-start-odds",
    title: "Startodds"
  }, outcomeLabels === null || outcomeLabels === void 0 ? void 0 : outcomeLabels.map((outcomeLabel, i) => {
    var _startOdds$current;
    return React.createElement(TableComponent.Body.Row.ContentCell, {
      key: "startOdds_".concat(drawNumber, "_").concat(outcomeLabel.text)
    }, formatDecimalOdds(startOdds === null || startOdds === void 0 || (_startOdds$current = startOdds.current) === null || _startOdds$current === void 0 ? void 0 : _startOdds$current.value[i]));
  })), shouldDisplayTioTidningar && React.createElement(TipsinfoTableRow, {
    dataTestId: "coupon-row-tips-info-ten-papers",
    title: "Tio Tidningar"
  }, outcomeLabels === null || outcomeLabels === void 0 ? void 0 : outcomeLabels.map((outcomeLabel, i) => {
    var _tioTidningarTips$cur;
    return React.createElement(TableComponent.Body.Row.ContentCell, {
      key: "tt_".concat(drawNumber, "_").concat(matchId, "_").concat(outcomeLabel.text)
    }, setUpTipsinfoValue({
      value: tioTidningarTips === null || tioTidningarTips === void 0 || (_tioTidningarTips$cur = tioTidningarTips.current) === null || _tioTidningarTips$cur === void 0 ? void 0 : _tioTidningarTips$cur.value[i],
      sign: '',
      noValueSign: hasTioTidningarValues ? '0' : '-'
    }));
  })), showMatchAnalyseForecast && React.createElement(AnalysisForecast, {
    dataTestId: "coupon-row-tips-info-analyse",
    drawId: drawNumber,
    eventNumber: eventNumber,
    matchId: matchId,
    productId: productId
  })));
};


setGlobal('svs.components.tipsen.tipsinfo.TipsinfoTable', TipsinfoTable);

 })(window);